import { AnnotationDirective, Annotations, AnnotationsDirective, AxesDirective, AxisDirective, Inject, LinearGaugeComponent, PointerDirective, PointersDirective } from '@syncfusion/ej2-react-lineargauge';
import React from 'react';
import Constants from '../../models/constants';
import Weather from '../../models/weather';
import './watercontent.css';

const WaterContent: React.FC<{weather: Weather}> = ({weather}) => {
    const moisture = weather.moisture?.moisture ?? 0;
    const irrigation_1day = weather.last7days?.irrigation[6] ?? 0;
    const irrigation_7day =weather.last7days?.irrigation?.reduce((a: number, c: number) => a + c) ?? 0;
    const moistureStr: string = moisture.toFixed(1);
    const irrigation_1dayStr: string = irrigation_1day.toFixed(1);
    const irrigation_7dayStr: string = irrigation_7day.toFixed(1);
    return (
        <div className="water-content-container">
            <div className='water-content-title'>
                Water Content
            </div>
            <div className='water-content-moisture-container'>
                <LinearGaugeComponent 
                    className='water-content-moisture-component' 
                    container={ { width:20, type:'RoundedRectangle', backgroundColor: Constants.darkBlue } } 
                    background={Constants.grey} 
                    orientation='Horizontal' 
                    >
                    <Inject services={[Annotations]}/>
                    <AxesDirective>
                        <AxisDirective 
                            maximum={100} 
                            minimum={0} 
                            majorTicks={{height: 0, interval: 0}} 
                            minorTicks={{height: 0, interval: 0}} 
                            line={{width: 0} }>
                            <PointersDirective>
                                <PointerDirective value={moisture} width={10} type='Bar' color={Constants.lightBlue}>
                                </PointerDirective>
                            </PointersDirective>
                        </AxisDirective>
                    </AxesDirective>
                    <AnnotationsDirective>
                        <AnnotationDirective content={'100%'} x={225} y={22} zIndex='1'>
                        </AnnotationDirective>
                    </AnnotationsDirective>
                </LinearGaugeComponent>
                <div className='big-text'>
                    Moisture
                </div>
                <div className='bigger-text'>
                    {moistureStr}%
                </div>
            </div>
            <div className='water-content-pair'>
                <LinearGaugeComponent 
                    className='water-content-component' 
                    container={ { width:15, type:'RoundedRectangle', backgroundColor: Constants.darkBlue  } } 
                    background={Constants.grey} 
                    >
                    <Inject services={[Annotations]}/>
                    <AxesDirective>
                        <AxisDirective 
                            maximum={50} 
                            minimum={0} 
                            majorTicks={{height: 0}} 
                            minorTicks={{height: 0}} 
                            labelStyle={{font: {size: '0'}}}
                            line={{width: 0} }>
                            <PointersDirective>
                                <PointerDirective value={irrigation_1day} width={15} type='Bar' color={Constants.lightBlue}>
                                </PointerDirective>
                            </PointersDirective>
                        </AxisDirective>
                    </AxesDirective>
                    <AnnotationsDirective>
                        <AnnotationDirective content={'50mm'} x={25} y={10} zIndex='1'>
                        </AnnotationDirective>
                    </AnnotationsDirective>
                </LinearGaugeComponent>
                <div className='water-content-texts-between'>
                    <div className='big-text'>
                        Irrigation
                    </div>
                    <div className='bigger-text'>
                        {irrigation_1dayStr}mm
                    </div>
                    <div className='small-text'>
                        Last 24 Hours
                    </div>
                    <div className='bigger-text'>
                        {irrigation_7dayStr}mm
                    </div>
                    <div  className='small-text'>
                        Last 7 Days
                    </div>
                </div>
                <LinearGaugeComponent 
                    className='water-content-component' 
                    container={ { width:15, type:'RoundedRectangle', backgroundColor: Constants.darkBlue  } } 
                    background={Constants.grey} 
                    >
                    <Inject services={[Annotations]}/>
                    <AxesDirective>
                        <AxisDirective 
                            maximum={500} 
                            minimum={0} 
                            majorTicks={{height: 0}} 
                            minorTicks={{height: 0}}
                            labelStyle={{font: {size: '0'}}}
                            line={{width: 0} }>
                            <PointersDirective>
                                <PointerDirective value={irrigation_7day} width={15} type='Bar' color={Constants.lightBlue}>
                                </PointerDirective>
                            </PointersDirective>
                        </AxisDirective>
                    </AxesDirective>
                    <AnnotationsDirective>
                        <AnnotationDirective content={'500mm'} x={20} y={10} zIndex='1'>
                        </AnnotationDirective>
                    </AnnotationsDirective>
                </LinearGaugeComponent>
            </div>
        </div>
    );
} 

export default WaterContent;